import { createContext } from 'react';
import { ComponentSettings } from '../types';

export const ConfigContext = createContext<ComponentSettings>(null);
